<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-clickhouse`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_822de1b17f__clip0_3418_263489)"><path d="M0 0.9375H1.69383V13.3678H0V0.9375ZM3.57438 0.9375H5.26821V15.0616H3.57438V0.9375ZM7.15543 0.9375H8.84926V15.0616H7.15543V0.9375ZM10.7298 0.9375H12.4236V15.0616H10.7298V0.9375ZM14.3109 6.58582H16.0047V9.41332H14.3109V6.58582Z" :fill="useCurrentColor ? 'currentColor' : '#FFCB14'"/><path d="M0 13.3691H1.69383V15.063H0V13.3691Z" :fill="useCurrentColor ? 'currentColor' : 'red'"/></g><defs><clipPath id="svg_822de1b17f__clip0_3418_263489"><path :fill="useCurrentColor ? 'currentColor' : '#fff'" d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconColorClickhouse',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
